import React, {createContext, useContext, useState} from 'react';

import Popup from '@parkagent/ui/dist/components/Popup'
import Button from '@parkagent/ui/dist/components/Button'
import Paragraph from '@parkagent/ui/dist/components/Paragraph'
import { Title } from '@parkagent/ui';

const Context = createContext({
    errors: [],
})

export function useError() {
    return useContext(Context);
}

export function ErrorContext(props) {

    const [errorPopup, setErrorPopup] = useState(false)

    function generalError({title, description, callback}) {
        setErrorPopup({
            title: title || "Opsss...",
            description: description || "Si è verificato un errore",
            onClick: () => {
                if(callback && typeof callback === "function") {
                    callback();
                }

                return setErrorPopup();
            }
        })
    }
    function setError(response, variables, params, callback) {
        console.log(response)
        console.log("setError", response, variables, params, callback)

        const {data} = response?.response || {};

        let title = "Opsss...";
        let description = "Si è verificato un errore";
        let onClick = undefined;
        let buttonText = undefined;
        let buttonComponent = undefined;
        let to = undefined;

        if (data?.message)  {
            description = data.message;
        }

        if (callback && typeof callback === "function") {
            onClick = callback
        }

        if(typeof response === "string") {
            description = response;
        }

        return setErrorPopup({
            title,
            description,
            onClick,
            to,
            buttonText,
            buttonComponent
        });
    }

    return (
        <Context.Provider
            value={{
                generalError,
                setError
            }}
        >

            {props.children}

            <Popup
                visible={!!errorPopup}
                setVisible={setErrorPopup}
                overflow="visible"
                small
            >
                <div className='p-5'>
                    <Title>{errorPopup?.title}</Title>
                    <div className='pt-3'>
                        <Paragraph>
                            {errorPopup?.description}
                        </Paragraph>
                    </div>
                    {errorPopup?.buttonText &&
                        <div className='pt-3'>
                            <Button
                                onClick={errorPopup.onClick}
                            >
                                {errorPopup.buttonText}
                            </Button>
                        </div>
                    }
                </div>
            </Popup>

        </Context.Provider>
    )
}